export default "__VITE_ASSET__ee432a4d__"